import React from 'react';
import { Box } from '@mui/material';
import { Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import CreateGrid from './register/CreateGrid';
import SelectorGrid from './register/SelectorGrid';
import SelectorButtons from './register/SelectorButtons';

// import '../css/jb-styles.css';
import AppHeader from './AppHeader';

export default function RegisterPattern() {
  const theme = useTheme();

  return (
    <React.Fragment>
      {/* <Box>
        <img src={gvLogo}
          alt="gridvault logoprivacy image"
          className='home-icon'
          style={{ width: '100%' }}
        />
      </Box> */}

      <AppHeader />

      <Box>
        <Typography variant='h5'
          sx={{
            color: '#3B4E68',
            fontWeight: 'bold',
          }}
        >
          Register your pattern
        </Typography>

      </Box>

      {/* <Box>
        <Typography variant='body1'
          sx={{
            fontSize: '0.8em',
            color: '#3B4E68',
          }}>
          Click on the dots - the order is important
        </Typography>

      </Box> */}


      {/* <SelectorGrid /> */}
      <CreateGrid />
      <SelectorButtons />

    </React.Fragment>
  );
}